<template>
  <div class="recharge">
    <HpsfirProTable
      ref="tableRef"
      :paginations="{ pageSize: 10 }"
      page-layout="total, sizes, prev, pager, next"
      :columns="columns"
      :get-data="getData"
      :on-add="addFun"
      :on-delete="deleteFun"
      :on-edit="updateFun"
      :loading="loading"
      :is-dangder-delete="true"
      :format-dangder-delete-info="formatDeleteInfo"
      row-key="id"
      :operates="operates"
      :add-init-values="addInitValue"
      :codition-init-values="conditionsInitValue"
    />
  </div>
</template>
<script lang="tsx" setup>
import {
  HpsfirProTable,
  HpsfirProTableColumn,
  HpsfirProTableData,
  HpsfirProTableFilter,
  HpsfirProTableGetDataFunction,
  useBaseAsync,
} from 'hpsfir-managebase-ui';
import { useApi } from '@/hooks/useApi';
import { ElMessage } from 'element-plus';
import { ref } from 'vue';

const columns = ref<HpsfirProTableColumn[]>([]);
const tableRef = ref<InstanceType<typeof HpsfirProTable>>();
const couponTypeOptions = ref<{ label: string; value: number }[]>([]);

const addInitValue = {
  sequence: 0,
  visible: true,
};

const conditionsInitValue = {
};

// 加载券类型选项
const loadCouponTypeOptions = useBaseAsync(async() => {
  const res = await useApi().couponTypeApi.listCouponTypecouponType({
    conditions: {},
  });
  couponTypeOptions.value = (res.data.data || []).map((item: any) => ({
    label: item.name,
    value: item.id,
  }));
});

// 创建列定义
const createColumns = () => [
  {
    name: 'sequence',
    label: '排序',
    type: 'number',
    min: 0,
    step: 1,
    width: 80,
  },
  {
    name: 'price',
    label: '价格(元)',
    type: 'string',
    rule: [
      { required: true, message: '请输入价格' },
      { pattern: /^(?!0(?:\.0{1,2})?$)\d+(?:\.\d{1,2})?$/u, message: '请输入正确的价格，最多保留2位小数' },
    ],
    width: 120,
  },
  {
    name: 'coins',
    label: 'D币数量',
    type: 'string',
    rule: [
      { required: true, message: '请输入D币数量' },
      { pattern: /^[1-9]\d*$/u, message: '请输入正整数' },
    ],
    width: 120,
  },
  {
    name: 'giftPoints',
    label: '赠送积分',
    type: 'string',
    rule: [{ pattern: /^$|^[1-9]\d*$/u, message: '请输入正整数' }],
    width: 120,
  },
  {
    name: 'giftCouponTypeId',
    label: '赠送券类型',
    type: 'select',
    options: couponTypeOptions.value,
    width: 150,
    render(scope: any) {
      const couponType = couponTypeOptions.value.find((item) => item.value === scope.row.giftCouponTypeId);
      return <span>{couponType ? couponType.label : '-'}</span>;
    },
  },
  {
    name: 'giftCouponCount',
    label: '赠送券数量',
    type: 'number',
    min: 0,
    step: 1,
    width: 120,
  },
  {
    name: 'visible',
    label: '是否显示',
    type: 'swtich',
    width: 100,
  },
  {
    name: 'createTime',
    label: '创建时间',
    type: 'string',
    hideEdit: true,
    hideCreate: true,
    width: 180,
  },
] as HpsfirProTableColumn[];


// 初始化
const init = useBaseAsync(async() => {
  await loadCouponTypeOptions();
  columns.value = createColumns();
});

const operates: any[] = [];

const loading = ref(false);

const getData = useBaseAsync<HpsfirProTableGetDataFunction>(async(filter: HpsfirProTableFilter) => {
  try {
    loading.value = true;
    const res = await useApi().rechargeApi.pageRechargerecharge({
      conditions: Object.entries(filter.conditions).reduce((conditions, [key, val]) => {
        if (val === null || val === undefined || val === '') {
          return conditions;
        }

        conditions[key] = val;

        return conditions;
      }, {} as any),
      pageQuery: {
        page: filter.paginations.page - 1,
        pageSize: filter.paginations.pageSize,
      },
    });

    const tableData: HpsfirProTableData = {
      total: res.data.data?.total || 0,
      data: res.data.data?.data || [],
    };
    return tableData;
  } finally {
    loading.value = false;
  }
});

const formatDeleteInfo = (row: any) => `您确定要删除"${row.price}元套餐"吗？此操作不可恢复，请谨慎操作。`;

const addFun = useBaseAsync(async(data: any) => {
  await useApi().rechargeApi.addRechargerecharge({
    rechargeAdminVo: {
      ...data,
    },
  });
  ElMessage.success('添加成功');
});

const updateFun = useBaseAsync(async(data: any) => {
  await useApi().rechargeApi.updateRechargerecharge({
    rechargeAdminVo: {
      ...data,
    },
  });
  ElMessage.success('修改成功');
});

const deleteFun = useBaseAsync(async(data: any) => {
  await useApi().rechargeApi.delRechargerecharge(data.id);
  ElMessage.success('删除成功');
});

Promise.all([init()]);
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
